<!--我的订单-->
<template>
  <div class="home-main promotionList">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">推广列表</span>
        <span class="title-en">/Promotion List</span>
      </div>
      <!--筛选部分start-->
      <div class="myOrder-selector">
        <div class="select-item">
          <p>公司名称</p>
          <el-input
            v-model="searchOption.user_company"
            class="select-input"
            size="small"
            clearable
          ></el-input>
        </div>
        <div class="select-item">
          <p>用户名</p>
          <el-input
            v-model="searchOption.user_name"
            class="select-input"
            size="small"
            clearable
          ></el-input>
        </div>
        <div class="select-item">
          <p>素材标题</p>
          <el-input
            v-model="searchOption.title"
            class="select-input"
            size="small"
            clearable
          ></el-input>
        </div>
        <div class="select-item" >
          <p>生成时间</p>
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="searchOption.createtime_start"
            type="date"
            align="right"
            :picker-options="pickerOptions1"
            size="small"
          >
          </el-date-picker>
          <span class="demonstration">到</span>
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="searchOption.createtime_end"
            type="date"
            align="right"
            :picker-options="pickerOptions2"
            size="small"
          >
          </el-date-picker>
        </div>
        <el-button size="small" class="warning" @click="search">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
      </div>
      <!--筛选部分end-->

      <div class="myOrder-main-line"></div>

      <!--订单列表start-->
      <div class="myOrder-main-list">
        <el-table height="100%" :data="tableData" style="width: 100%;" stripe>
          <el-table-column width="40"> </el-table-column>
          <el-table-column label="用户名">
            <template slot-scope="scope">
              <span>{{ scope.row.user_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="真实姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.profile.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="公司名称">
            <template slot-scope="scope">
              <span>{{ scope.row.profile.company }}</span>
            </template>
          </el-table-column>

          <el-table-column label="产品类别">
            <template slot-scope="scope">
              <span>{{ scope.row.template?scope.row.template.product:"" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="内容标签">
            <template slot-scope="scope">
              <span>{{ scope.row.template?scope.row.template.category:"" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="素材标题">
            <template slot-scope="scope">
              <span>{{ scope.row.template?scope.row.template.title:"" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="生成时间">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--订单列表end-->
      <div class="pagination">
        <el-pagination
          :disabled="!pagination.use"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getPromotionByParam } from "@/api/promotion";
import { createGetUrlParams } from "@/utils/url";
export default {
  data() {
    return {
      /*筛选条件-产品start*/

      loading: false,
      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },

      // 筛选条件
      searchOption: {
        user_name: "",
        user_company: "",
        title: "",
        createtime_start: "",
        createtime_end: "",
      },
      pickerOptions1: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近7天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", date);
            },
          },
          {
            text: "最近1年",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },

      /*表格数据start*/
      tableData: [],
    };
  },
  mounted() {
    // console.log(this.$store.getters.userInfo.is_superuser);
    this.getMaterialData();
  },
  methods: {
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getMaterialData();
    },
    handleSizeChange(val) {
      if (val <= this.pagination.total) {
        this.pagination.size = val;
        this.getMaterialData();
      }
    },

    getMaterialData() {
      this.loading = true;
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size,
      };
      let result = createGetUrlParams(params);
      if (result.success) {
        getPromotionByParam(result.data)
          .then((response) => {
            this.loading = false;
            this.pagination.total = response.count | 0;
            this.tableData = response.results;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    search() {
      let params = this.searchOption;
      let result = createGetUrlParams(params);
      if (result.success) {
        this.loading = true;
        getPromotionByParam(result.data)
          .then((response) => {
            this.tableData = response.results;
            this.loading = false;
            this.pagination.total = response.count | 0;
          })
          .catch(() => {
            this.loading = false;
          });
        this.restPage(false);
      }
    },
    resetSearch() {
      this.restPage(true);
      this.searchOption = {
        user_name: "",
        user_company: "",
        title: "",
        createtime_start: "",
        createtime_end: "",
      };
      this.getMaterialData();
    },
    restPage(isUsePagination) {
      this.pagination.use = isUsePagination;
      this.pagination.currentPage = 1;
      this.pagination.size = 20;
    },
  },
  computed: {
    headers() {
      return {
        Authorization: `token ${this.$store.getters.token}`,
      };
    },
  },
};
</script>

<style lang="scss">
/*筛选部分start*/
.promotionList {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    //background-color: #FFFFFF;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    .main_title {
      margin: 15px 0;
    }
    .myOrder-main-list {
      flex-grow: 1;
    }
    .main-title-right {
      float: right !important;
      width: 130px !important;
      height: 66px !important;
      line-height: 66px !important;
    }
  }
  .myOrder-selector {
    padding: 18px 0px 20px 24px !important;
    min-width: 980px !important;
    font-size: 12px !important;
    height: 32px !important;
    background: #fff;
  }

  .meterial-upload {
    .el-form-item__content {
      display: flex;
    }
    .el-button {
      border: 0px !important;
      background-color: rgba(64, 158, 255, 0) !important;
    }
    .el-button {
      border: 0px !important;
      background-color: rgba(64, 158, 255, 0) !important;
    }
    .el-button span {
      color: #0090ee !important;
      font-size: 14px;
    }
  }

  .myOrder-main-list .cell .el-button {
    border: 0px !important;
    background-color: rgba(64, 158, 255, 0) !important;
  }
  .myOrder-main-list .cell .el-button {
    margin-left: 0px !important;
    padding: 2px 5px !important;
  }
  .myOrder-main-list .cell .el-button span {
    color: #0090ee !important;
  }
}

.select-item {
  float: left !important;
  margin-right: 34px !important;
}

.select-item .el-date-editor {
  width: 180px !important;
}

.select-item .el-input__inner {
  padding-right: 0px !important;
}

.select-item p {
  padding-right: 10px !important;
  float: left !important;
  height: 32px !important;
  line-height: 32px !important;
  text-align: right !important;
}

.select-input {
  float: left !important;
  width: 180px !important;
}

.select-item .el-select {
  width: 200px !important;
}

.select-item .el-select .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.select-item .el-select {
  .el-input__suffix {
    top: 5px;
  }
  .el-input__icon {
    line-height: inherit;
  }
  .el-input__suffix-inner {
    display: inline-block;
  }
}

.el-select-dropdown__list {
  padding: 6px 0px 22px 0px !important;
}

.el-select-dropdown span {
  font-size: 12px !important;
}
/*筛选部分end*/

.myOrder-main-line {
  width: 100% !important;
  border-bottom: 1px solid #ededed !important;
}

/*订单列表start*/
.myOrder-main-list {
  min-width: 1100px !important;
  height: 430px;
  /*margin-top: 10px!important;*/
  /*margin:35px 30px 0px 30px!important;*/
}

.myOrder-main-list .cell span {
  font-size: 12px !important;
}

/*订单列表end*/
</style>



// WEBPACK FOOTER //
// src/components/material/promotionList.vue